export enum Language {
	pl = 'pl',
	en = 'en',
	ua = 'ua',
}
